import TradeSummary from './components/TradeSummary';

export default TradeSummary;
